import { Injectable, inject } from '@angular/core';
import { Constants } from '@core/app-constants';
import {
  CancelOrderOperationRequestDto,
  OrderOperationClient,
  OrderOperationPlanResponseDto,
  OrderOperationResultResponseDto,
} from '@core/services/apiclient';
import { HttpHandlerService } from '@core/services/http-handler.service';
import { Observable } from 'rxjs';

/**
 * Pipeline `orders/operations` : une seule transaction pour des cibles hétérogènes, l'intention
 * portée par la ROUTE (annuler) et la chose visée par une union discriminée (`kind`).
 *
 * C'est le seul chemin qui sache annuler une place sur TOUTES les séances d'une formule : le
 * `POST sales/order-seats/cancel` historique refuse par construction des places réparties sur
 * plusieurs lignes de commande (une formule en a une par séance).
 *
 * Le preflight ne calcule rien de plus que la commande elle-même — il est là pour afficher le
 * montant à rendre avant d'écrire, pas pour autoriser l'écriture.
 */
@Injectable({
  providedIn: 'root',
})
export class OrdersOperationsService {
  private readonly orderOperationClient = inject(OrderOperationClient);
  private readonly httpHandlerService = inject(HttpHandlerService);

  cancel(request: CancelOrderOperationRequestDto): Observable<OrderOperationResultResponseDto> {
    return this.orderOperationClient
      .cancel(request, Constants.ApiVersion)
      .pipe(this.httpHandlerService.handleApiResponse<OrderOperationResultResponseDto>());
  }

  cancelPreflight(request: CancelOrderOperationRequestDto): Observable<OrderOperationPlanResponseDto> {
    return this.orderOperationClient
      .cancelPreflight(request, Constants.ApiVersion)
      .pipe(this.httpHandlerService.handleApiResponse<OrderOperationPlanResponseDto>());
  }
}
